import React, { Component } from 'react'
import { connect } from 'react-redux'

// Actions
import { getPriceList, updatePriceList } from '../../../actions/priceModel'

// import styles
import './discounts.scss'

// Utils
import { reverseFormatCurrency2 } from '../../../utils/currency'
import { translation, enumtranslate } from '../../../utils/helpers'
import { hasSubscriptionPermission } from '../../../utils/auth'

// Elements
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Grid from '../../../shared/elements/grid'
import DecimalInput from '../../../shared/components/DecimalInput'
import PriceCalculationType from './PriceCalculationType'
// import HelpText from '../../../shared/components/HelpText'

class Discounts extends Component {
  constructor (props) {
    super(props)
    this.state = {
      customerId: 0,
      price: null,
      currentItem: {
        index: -1,
        discount: null
      }
    }
    this.sortItems = this.sortItems.bind(this)
  }

  componentDidMount () {
    this.loadPriceModel(this.props)
  }
  componentWillUpdate (nextProps) {
    if (this.props.item.PriceModelId !== nextProps.item.PriceModelId || this.props.type !== nextProps.type) {
      this.loadPriceModel(nextProps)
    }
  }

  sortItems (items) {
    let kickbackOrderTypes = [1, 10] // easy expansion if more is added later
    items.forEach(item => {
      if (this.props.hasKickback && kickbackOrderTypes.indexOf(item.OrderType) > -1 && !item.IsAddonPrice) {
        item.isKickBack = true
      } else {
        item.isKickBack = false
      }
    })
    // sort OrderType 1,2,3,6,4,5,Mersalg
    let index = items.findIndex(item => item.OrderType === 1 && item.IsAddonPrice === true)
    let addon
    if (index !== -1) addon = items.splice(index, 1)
    let order = [1, 2, 3, 6, 4, 5]
    // items = order.map(id => {
    //   items.find(ob => ob.OrderType === id)
    // })
    items = items.map(({ OrderType }, i) => ({ item: order.indexOf(OrderType), index: i }))
      .sort((a, b) => a.item - b.item || a.index - b.index)
      .map(({ index }) => items[index])
    items.push(addon[0])
    return items
  }

  loadPriceModel (props) {
    let customerId = props.customerId
    this.props.getPriceList(props.item.PriceModelId, customerId).then((res) => {
      res.data.CustomerDiscounts.Discounts = this.sortItems(res.data.CustomerDiscounts.Discounts)
      this.setState({
        customerId: customerId,
        price: res.data
      })
    }, () => {
      // Toastr
      window.toastr.error(translation('13445'), translation('216'))
      this.props.router.push('/prices')
    })
  }

  getDiscountSetIndex (price, withRental) {
    let items = price.CustomerDiscounts.Discounts
    let index = items.findIndex((i) => {
      if (this.props.type === 'Addon') {
        return i.OrderType === 1 && i.IsAddonPrice
      } else {
        let type = parseInt(this.props.type)
        if (withRental) { // Rates for use with rental cars: Insurance (1) becomes Insurance_Rental (10)
          type *= 10
        }
        return i.OrderType === type && !i.IsAddonPrice
      }
    })
    return index
  }

  updateDiscounts (withRental) {
    this.props.updatePriceList(this.state.price).then((res) => {
      res.data.CustomerDiscounts.Discounts = this.sortItems(res.data.CustomerDiscounts.Discounts)
      this.setState({
        price: res.data
      })
      // Toastr
      // window.toastr.success(translation('15157'), translation('13424'))
    }, () => {
      // Toastr
      window.toastr.error(translation('13445'), translation('216'))
      this.props.router.push('/prices')
    })
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 10)) return null
    if (!this.state.price) return null

    const renderDiscounts = () => {
      if (this.state.price === null || this.state.price === undefined) return null

      const renderBodyDiscountFields = () => {
        if (!this.state.price) return null
        let discountIndex = this.getDiscountSetIndex(this.state.price)
        let currentDiscount = this.state.price.CustomerDiscounts.Discounts[discountIndex]
        let discountIndexRental = null
        let currentDiscountRental = null
        if (this.props.hasKickback && this.props.isBodyShop) {
          discountIndexRental = this.getDiscountSetIndex(this.state.price, true)
          currentDiscountRental = this.state.price.CustomerDiscounts.Discounts[discountIndexRental]
        }

        // splice data for rendering
        let itemsToRender = { ...currentDiscount }
        if (currentDiscountRental) {
          Object.keys(currentDiscountRental).map(k => {
            itemsToRender[k + '-Rental'] = currentDiscountRental[k]
          })
        }

        const onChangeAmount = (e) => {
          let amount = e.target.value
          let name = e.target.name
          if (name.endsWith('-Rental')) {
            currentDiscountRental[name.substring(0, name.length - 7)] = amount
          } else {
            currentDiscount[name] = amount
          }
          let update = { ...this.state.price }
          update.CustomerDiscounts.Discounts[discountIndex] = currentDiscount
          if (currentDiscountRental) {
            update.CustomerDiscounts.Discounts[discountIndexRental] = currentDiscountRental
          }
          this.setState({
            price: update
          })
        }

        const onAmountBlur = (e) => {
          let amount = e.value
          let name = e.name
          if (isNaN(amount)) {
            // Toastr
            window.toastr.error(translation('15159'), translation('216'))
          } else if (amount < 0 || amount > 99.99) {
            // Toastr
            window.toastr.error(translation('15158'), translation('216'))
          } else {
            if (name.endsWith('-Rental')) {
              currentDiscountRental[name.substring(0, name.length - 7)] = amount
            } else {
              currentDiscount[name] = amount
            }
            let update = { ...this.state.price }
            update.CustomerDiscounts.Discounts[discountIndex] = currentDiscount
            if (currentDiscountRental) {
              update.CustomerDiscounts.Discounts[discountIndexRental] = currentDiscountRental
            }
            this.setState({
              price: update
            }, () => {
              this.updateDiscounts()
            })
          }
        }

        const renderFields = (label, name1, name2) => {
          const renderField = (name) => {
            return (
              <DecimalInput
                name={name}
                value={itemsToRender[name]}
                onChange={onChangeAmount}
                onBlur={onAmountBlur}
                size='m'
              />
            )
          }
          let cols = name2 ? ['40%', '1fr', '1fr'] : ['1fr', '1fr']
          return (
            <Grid align='center' spacing={1} key={name1} cols={cols}>
              <span>{label}</span>
              {name1 && renderField(name1)}
              {name2 && renderField(name2)}
            </Grid>
          )
        }

        if (this.props.isBodyShop) {
          if (this.props.hasKickback && currentDiscount.OrderType === 1 && currentDiscount.IsAddonPrice !== true) {
            return [
              renderFields(translation('416'), 'Salary', 'Salary-Rental'),
              renderFields(translation('637'), 'SpareParts', 'SpareParts-Rental'),
              renderFields(translation('15154'), 'Misc', 'Misc-Rental'),
              renderFields(translation('660'), 'Paint', 'Paint-Rental'),
              renderFields(translation('15155'), 'PaintMaterialsEnv', 'PaintMaterialsEnv-Rental'),
              renderFields(translation('15156'), 'SalaryEnv', 'SalaryEnv-Rental'),
              renderFields(translation('15214'), 'Deduction', 'Deduction-Rental')
            ]
          } else {
            return [
              renderFields(translation('416'), 'Salary'),
              renderFields(translation('637'), 'SpareParts'),
              renderFields(translation('15154'), 'Misc'),
              renderFields(translation('660'), 'Paint'),
              renderFields(translation('15155'), 'PaintMaterialsEnv'),
              renderFields(translation('15156'), 'SalaryEnv'),
              (currentDiscount.OrderType === 1 && currentDiscount.IsAddonPrice !== true && renderFields(translation('15214'), 'Deduction'))
            ]
          }
        } else {
          return [
            renderFields(translation('548'), 'Amount'),
            renderFields(translation('13379'), 'Environment')
          ]
        }
      }

      const renderHeadings = (isKickback) => {
        let amountText = '1295'
        let amountText2 = null

        // Bodyshop discounts
        let headingText = ''

        if (this.props.type === 'Addon') { // Addon
          headingText = translation('1396')
        } else {
          if (parseInt(this.props.type) === 1) { // Insurance claim
            headingText = translation('70')
            if (isKickback === true) {
              amountText = '18391'  // without rental car
              amountText2 = '18390' // with rental car
              // amountText = '14904'
              // amountText2 = '18390'
            }
          } else {
            headingText = translation(enumtranslate('OrderTypes', parseInt(this.props.type)))
          }
        }

        if (isKickback === true && this.props.isBodyShop === false) {
          amountText = '14904'
        }

        return (
          <Grid cols={amountText2 ? ['40%', '1fr', '1fr'] : ['1fr', '1fr']} align='center' spacing={1}>
            <span>{headingText}</span>
            <span>{translation(amountText)}</span>
            {amountText2 && <span>{translation(amountText2)}</span>}
          </Grid>
        )
      }

      return (
        <div>
          {this.props.hasKickback ? renderHeadings(true) : renderHeadings(false)}
          {renderBodyDiscountFields()}
        </div>
      )
    }

    const isReturnCommission = this.props.hasKickback && parseInt(this.props.type) === 1
    let titleText = translation('1197')
    if (isReturnCommission) {
      titleText = translation('14898')
    }

    let helpText = ''
    switch (this.props.auth.departmentType) {
      case 0:
        helpText = `${translation('15026')} ${translation('15037')}`
        break
      case 1:
        helpText = isReturnCommission ? translation('15212') : translation('15036')
        break
      case 2:
        helpText = `${translation('15026')} ${translation('15037')}`
        break
    }

    const priceCalculationType = () => {
      if (this.props.auth.departmentType !== 0 || this.state.customerId <= 0) return null
      let index = this.state.price.CustomerDiscounts.Discounts.findIndex(x => x.OrderType === 1)
      if (index === -1) return null

      const onChange = ({ target: { name, value, checked } }, save) => {
        if (name === 'PriceCalculationType') value = parseInt(value)

        let price = { ...this.state.price }
        price.CustomerDiscounts.Discounts[index][name] = value
        this.setState({ price: price }, () => save && onBlur()) // If check mark / radio button, save
      }

      const onBlur = () => {
        let price = { ...this.state.price }
        price.CustomerDiscounts.Discounts[index].PriceHourly = reverseFormatCurrency2(price.CustomerDiscounts.Discounts[index].PriceHourly)
        this.setState({ price: price }, () => this.updateDiscounts())
      }

      return (
        <Col>
          <PriceCalculationType item={this.state.price.CustomerDiscounts.Discounts[index]} onChange={onChange} onBlur={onBlur} />
        </Col>
      )
    }

    return (
      <div>
        <Col span='3'>
          <Panel title={titleText} helpText={helpText}>
            {renderDiscounts()}
          </Panel>
        </Col>
        {parseInt(this.props.type) === 1 ? priceCalculationType() : null}
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getPriceList,
  updatePriceList
})(Discounts)



// WEBPACK FOOTER //
// ./src/app/pages/Prices/Discounts/index.js